module.exports = __webpack_public_path__ + "img/item_CommIllustration_03c.17deb564.jpeg";